import { render, staticRenderFns } from "./profile-bank.vue?vue&type=template&id=11864d56&"
import script from "./profile-bank.vue?vue&type=script&lang=js&"
export * from "./profile-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports